import React from "react";
import { Stack, Typography } from "@mui/material";

import EmptyImage from "assets/bcba_dashboar_empty_section.png";

const EmptyCaseloadSummary = () => {
  return (
    <Stack alignItems="center" textAlign="center" my={5} data-testid="empty-caseload-summary">
      <img src={EmptyImage} height={223} alt="Empty caseload summary" />
      <Typography variant="subtitle1">No caseload data to display.</Typography>
      <Typography variant="body2" color="text.secondary">
        Once clients are assigned and sessions are recorded, the caseload summary will appear here.
      </Typography>
    </Stack>
  );
};

export default EmptyCaseloadSummary;
